export default {
    setList(state, data) {
        state.list = data.coupons.data
        state.total = data.coupons.total
    }
}
